<template>
	<div>
		<el-dialog
			:visible.sync="addEditInputDialog"
			:before-close="handleClose"
			:title="storeObj.type == 'ADD' ? 'Add Input Type' : 'Edit Input Type'"
			:fullscreen="false"
			width="550px"
		>
			<el-row :gutter="10">
				<el-col style="margin-top: 10px" :span="4" :offset="1">
					<div>Input Type</div>
				</el-col>
				<el-col :span="16">
					<el-select
						class="select"
						v-model="inputType"
						filterable
						placeholder="Select Input Type"
						clearable
						@change="selectedInputType(inputType)"
					>
						<el-option
							style="height: 55px"
							v-for="(item, idx) in inputItems.filter(
								(el) =>
									!inputType ||
									el.title.toLowerCase().includes(inputType.toLowerCase())
							)"
							:key="idx"
							:value="item.title"
						>
							<el-row :gutter="3">
								<el-col :span="4">
									<el-card
										shadow="never"
										style="height: 49px; border-radius: 12px; margin-top: 5px"
									>
										<div style="margin-top: -5px" v-if="item.img2">
											<el-image :src="item.img2" fit="contain"></el-image>
										</div>
										<div
											style="margin-top: -14px; margin-left: -3px"
											v-if="item.card"
										>
											<b v-if="item.card != 'C'">{{ item.card }}</b>
											<b v-if="item.card == 'C'"
												><div>
													{{ item.card }}
													<div style="margin-top: -40px; margin-left: 10px">
														o
													</div>
												</div>
											</b>
										</div>
									</el-card>
								</el-col>
								<el-col style="margin-left: 10px" :span="19">
									<div style="font-weight: bold">
										{{ item.title }}
									</div>
									<div style="font-size: 10px; margin-top: -15px">
										{{ item.subTitle }}
									</div>
								</el-col>
							</el-row>
						</el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 30px; margin-top: 20px" :gutter="10">
				<el-col style="margin-top: 10px" :span="4" :offset="16">
					<el-button
						@click="add_edit_input_method()"
						class="button-class"
						style="width: 100px"
					>
						save
					</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>

<script>
import items from "./inputTypeItems.js";
import formBuilderServices from "../../../services/formBuilderServices";

export default {
	props: {
		addEditInputDialog: Boolean,
		storeObj: Object,
		inputTypeItems: Array,
	},
	data: () => ({
		inputType: "",
		inputItems: [],
		selectedDataType: "",
	}),
	watch: {
		addEditInputDialog(val) {
			if (val) {
				this.inputItems = items;
			}
		},
	},
	methods: {
		add_edit_input_method() {
			if (this.storeObj.type == "ADD") {
				let params = {
					name: this.inputType,
					serial_no: this.inputTypeItems.length + 1,
					input_data_type: this.selectedDataType,
				};
				formBuilderServices.addInputType(params).then((res) => {
					console.log(res);
					this.$emit("clicked");
				});
			}
		},
		selectedInputType(inputType) {
			this.selectedDataType = "";
			for (let i = 0; i < this.inputItems.length; i++) {
				if (this.inputItems[i].input_data_type) {
					if (this.inputItems[i].title == inputType) {
						this.selectedDataType = this.inputItems[i].input_data_type;
					}
				}
			}
			console.log(this.selectedDataType, "this.selectedDataType");
		},
		handleClose() {
			this.$emit("close");
		},
	},
};
</script>

<style></style>
